var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_593_1099)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 35,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1667 43.5833H48.3333V45.1667H45.1667V43.5833ZM51.5 45.1667H54.6667V43.5833H51.5V45.1667ZM45.1667 51.5H48.3333V49.9167H45.1667V51.5ZM51.5 51.5H54.6667V49.9167H51.5V51.5ZM45.1667 32.5H48.3333V30.9167H45.1667V32.5ZM51.5 32.5H54.6667V30.9167H51.5V32.5ZM45.1667 38.8333H48.3333V37.25H45.1667V38.8333ZM51.5 38.8333H54.6667V37.25H51.5V38.8333ZM61 26.9583V61H23V36.1876C23 35.1299 23.4117 34.1356 24.159 33.3883L28.4451 29.1022C30.163 27.3843 33.2521 27.3843 34.97 29.1022L38.8317 32.9639V26.9583C38.8317 24.7765 40.6082 23 42.7901 23H57.0401C59.2219 23 61 24.7765 61 26.9583ZM38.8333 36.1876C38.8333 35.5527 38.5863 34.9573 38.1383 34.5077L33.8522 30.2216C32.7233 29.0927 30.695 29.0927 29.5661 30.2216L25.2784 34.5077C24.8303 34.9573 24.5833 35.5527 24.5833 36.1876V59.4167H38.8333V36.1876ZM59.4167 26.9583C59.4167 25.6489 58.3511 24.5833 57.0417 24.5833H42.7917C41.4823 24.5833 40.4167 25.6489 40.4167 26.9583V59.4167H59.4167V26.9583ZM29.3333 45.1667H34.0833V43.5833H29.3333V45.1667ZM29.3333 38.8333H34.0833V37.25H29.3333V38.8333ZM29.3333 51.5H34.0833V49.9167H29.3333V51.5Z",
    fill: "#00715D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_593_1099",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_593_1099"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_593_1099",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/Private.efee21bbbd185fe79e5f0834b3ee7534.svg";
export { ForwardRef as ReactComponent };